import { render, staticRenderFns } from "./PublicHearingPanel.vue?vue&type=template&id=12a621ec&scoped=true&"
import script from "./PublicHearingPanel.vue?vue&type=script&lang=js&"
export * from "./PublicHearingPanel.vue?vue&type=script&lang=js&"
import style0 from "./PublicHearingPanel.vue?vue&type=style&index=0&id=12a621ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a621ec",
  null
  
)

export default component.exports